import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { getToken } from '../../services/authToken';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * useInstructorReviewDetail — GET /api/instructor/interview-sim/{id}
 * Returns full session detail for instructor review.
 *
 * Error handling:
 *  - 401/403 → error state (auth / permission)
 *  - Other errors (4xx/5xx/network) → error state, detail stays null
 *  No mock fallback — production must surface real errors.
 */
export function useInstructorReviewDetail(sessionId) {
  const [detail, setDetail] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchDetail = useCallback(async () => {
    if (!sessionId) return;
    setLoading(true);
    setError(null);
    try {
      const token = getToken();
      const res = await axios.get(`${API}/instructor/interview-sim/${sessionId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setDetail(res.data);
    } catch (err) {
      setDetail(null);
      setError(err?.response?.data?.message_tr || err?.response?.data?.detail || err.message);
    } finally {
      setLoading(false);
    }
  }, [sessionId]);

  useEffect(() => {
    fetchDetail();
  }, [fetchDetail]);

  return { detail, loading, error, refetch: fetchDetail };
}
